module.exports = [{
      plugin: require('C:/Users/Adrian/Documents/ThunderLandings/QuantumChalkCom/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/Adrian/Documents/ThunderLandings/QuantumChalkCom/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
